/**
 * Embed: A class that place embedded content in dom
 *
 *
 */

; (function ($, window) { // eslint-disable-line no-extra-semi
  'use strict';

  /**
   * Embed component constructor
   * @param $element
   * @param targets
   * @param auto
   */
  var Embed = function ($element, data, auto, cookieName) {
      this.$el = $element;
      this.$target = $(data.target);
      this.$embed;
      this._data = data;
      this._embedOptions = $.extend(true, {}, Embed.defaults, this.$target.data('embed'));
      this.cookieName = cookieName;
      this.cookie = this.GetCookie(this.cookieName) === 'allow' ? true : false;
      this.YTLoades = false;

      /**
       * Auto-anchor as soon as we hit an `auto` = true
       */
      if (auto === true && this.cookie) {
          this._embedOptions.mute = true; //set audio off
          this.SetObject();
      }


      this.$el.on('click', function (e) {
          this.cookie = this.GetCookie(this.cookieName) === 'allow' ? true : false; //check again
          this.cookie = true;
          // console.log(this.cookie, this.cookieName);
          if (this.cookie) {
              this.SetObject();
          } else {
              this.setCookieMessage();
          }

          e.preventDefault();

      }.bind(this));
  };

  Embed.defaults = {
      class_is_active: 'is--active',
      class_is_loading: 'is--loading',
      height: '390px',
      widows: '640px',
      mute: false,
      data: [],
      youtube: {
          enablejsapi: 1,
          rel: 0,
          showinfo: 0,
          cc_load_policy: 1,
          controls: 1,
          modestbranding: 0,
          color: 'white'
      }
  };

  /**
   * Scroll funcition
   */
  Embed.prototype.SetObject = function () {
      var self = this;

      if (this._embedOptions.type == 'youtube')
          this.SetYoutube();
  };

  /**
   * setCookieMessage
   */

  Embed.prototype.setCookieMessage = function () {
      var self = this;
      self.$el.parent().addClass('cookie-not-accepted');

      setTimeout(function () {
          self.$el.parent().removeClass('cookie-not-accepted');
      }, 3000);
  }

  /**
   * get cookies
   */
  Embed.prototype.GetCookie = function (string) {
      var match = document.cookie.match(new RegExp('(^| )' + string + '=([^;]+)'));
      if (match) {
          return match[2];
      }
  };

  Embed.prototype.ActiveYoutube = function () {
    var self = this;



    if(!self.YTLoades) {

      window.onYouTubeIframeAPIReady = function () {
        self.YTLoades = true;

          //set elements active
          self._toggleElements();

          self.$embed = new YT.Player(self._embedOptions.placeholder, {
              height: self._embedOptions.height,
              width: self._embedOptions.width,
              playerVars: self._embedOptions.youtube, //no related videos
              videoId: youtube_parser(self._embedOptions.url),
              events: {
                  'onReady': onPlayerStart,
                  'onError': onPlayerError,
                  'onStateChange': onPlayerStateChange,
              }
          });
      }
    } else {

      onPlayerStart();
    }

    //Start player
      function onPlayerStart(event) {
        //event.target.playVideo();
        // console.log(self.$embed);
        self.$embed.playVideo();

        //check mute
        if (self._embedOptions.mute) {
            //self.$embed.mute();
            event.target.mute();
            self._embedOptions.mute = false;
        }
    }

    //Error
    function onPlayerError(event) {
        console.debug(event);
    }

    //State change youtube iframe player
    function onPlayerStateChange(event) {
        //console.log(event);

        if (event.data == 1) { //YT.PlayerState.PLAYING
            self.$target.removeClass(self._embedOptions.class_is_loading);
        }

        if (event.data == 3) { //YT.PlayerState.BUFFERING
            self.$target.addClass(self._embedOptions.class_is_loading);
        }

        if (event.data == 0) { //YT.PlayerState.ENDED
            // self.$embed.seekTo(0);
            event.target.seekTo(0);
            self.$embed.pauseVideo();
            self._toggleElements();

            //player.destroy();
        }
    }

    //return youtube id from url
    function youtube_parser(url) {
        var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
        var match = url.match(regExp);
        return (match && match[7].length == 11) ? match[7] : false;
    }
  }



  /**
   * Youtube
   */
  Embed.prototype.SetYoutube = function () {
      var self = this;


      //set loading class to embed oject
      self.$target.addClass(self._embedOptions.class_is_loading);



      //check if youtube scripti is loaded or exist

      // if (!window.onYouTubeIframeAPIReady) {



          // var tag = document.createElement('script'),
          //     firstScriptTag = document.getElementsByTagName('script')[0];

          // tag.src = "https://www.youtube.com/iframe_api";
          // firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        if(!this.YTLoades) {
          $.ajax({
            type: "GET",
            url: "https://www.youtube.com/iframe_api",
            succes: self.ActiveYoutube(),
            dataType: "script"
          });
        } else {
          self._toggleElements();
          self.$embed.playVideo();
          // onPlayerStart();
        }



      // } else {
          //if script exist and iframe is loaded toggle elements and start player

         //  self._toggleElements();
          //onPlayerStart();
      // }

      //Start player

  }

  Embed.prototype._toggleElements = function () {
      var self = this;

      for (var selector in this._data.toggles) {
          var $target = selector === 'this' ? self.$el : $(selector),
              className = self._data.toggles[selector];

          self._toggleElement($target, className);
      }
  };

  Embed.prototype._toggleElement = function ($target, className) {
      $target.toggleClass(className);
  };


  /**
   * Attach new anchor
   * @private
   */
  Embed.prototype._attach = function () {
      var $el = $(this),
          cookie = $el.data('cookie-name'),
          data = $el.data('toggle-video'),
          auto = $(data.target)[0].hasAttribute('data-video-auto') || false;

      new Embed($el, data, auto, cookie);
  };

  /**
   * Attach listeners to document
   */
  $(function () {
      /**
       * Travel through the DOM for data-at-modal attributes
       * For each of the founded data attr create a anchor scroll
       */
      $('[data-toggle-video]').each(Embed.prototype._attach);

  });

})(jQuery, window);
